import { useId, type ReactNode } from "react";
import { Link } from "wouter";

const UNAVAILABLE_MESSAGE = "Start a conversation from their listing, or message someone you already work with.";

type ProfileMessageActionProps = {
  href: string | null;
  canMessage: boolean;
  className: string;
  label: string;
  children: ReactNode;
  tooltipAbove?: boolean;
};

export function ProfileMessageAction({ href, canMessage, className, label, children, tooltipAbove = false }: ProfileMessageActionProps) {
  const tooltipId = useId();
  if (!href) return null;
  if (canMessage) return <Link href={href} className={className} aria-label={label}>{children}</Link>;

  // The disabled action stays focusable so keyboard users can read why it is unavailable.
  return <span role="button" aria-disabled="true" aria-label={label} aria-describedby={tooltipId} tabIndex={0} className="group relative inline-flex cursor-not-allowed">
    <span className={`${className} pointer-events-none opacity-50`}>{children}</span>
    <span id={tooltipId} role="tooltip" className={`pointer-events-none absolute right-0 z-30 w-64 max-w-[85vw] rounded-lg bg-navy px-3 py-2 text-xs font-medium text-white opacity-0 shadow-lg transition-opacity group-hover:opacity-100 group-focus:opacity-100 ${tooltipAbove ? "bottom-full mb-2" : "top-full mt-2"}`}>
      {UNAVAILABLE_MESSAGE}
    </span>
  </span>;
}
